/* */

export default function DownloadFromShareBase(sharebaseDoc, fileName) {
	var url = '/api/try/sharebase/get-sharebase-file/' + sharebaseDoc;
	var xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'arraybuffer';

	xhr.onload = function () {
		if (this.status === 200) {
			var filename = fileName;
			var type = xhr.getResponseHeader('Content-Type');

			var blob = new Blob([this.response], { type: type });

			var URL = window.URL || window.webkitURL;
			var downloadUrl = URL.createObjectURL(blob);

			if (filename) {
				var a = document.createElement("a");
				// safari doesn't support this yet
				if (typeof a.download === 'undefined') {
					window.location = downloadUrl;
				} else {
					a.href = downloadUrl;
					a.download = filename;
					document.body.appendChild(a);
					a.click();
				}
			} else {
				window.location = downloadUrl;
			}
			$('#download-controls-modal').modal('hide');
			$('#downloadSpinner').hide();
			setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup

		} else if (this.status === 401) {
			alert('Unauthorized. Please log in to access this content.');
		}else {
			alert('There was an error downloading the document.');
			console.log(this);
			$('#lab-controls-modal').modal('hide');
			$('#spinner').hide();
		}
	};

	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhr.send();
}
